import React, { Component } from 'react';
import { Grid, Row, Col } from 'react-bootstrap';
import './JobAdvertLayout.css';

class JobAdvertLayout extends Component {
  render() {
    return (
      <div className="job-advert-layout">
        <Grid>
          <Row>
            <Col md={8} mdOffset={2}>
              <h1>{this.props.jobtitle}</h1>
              <h3>{this.props.description}</h3>
              <h4>Who we are</h4>
              <p>
                We are a tech startup based in Edinburgh, the beautiful capital in
                the heart of Scotland. We are using blockchain to help food & drink
                producers better understand their supply chain and customers. Our
                end-to-end platform provides full traceability, process control analytics
                and compliance support. In 2017, we launched the world’s first blockchain-enabled
                beer, allowing the brewer and customers to connect in a way not possible before,
                and we are doing the same with Scottish whisky. We are now scaling our platform for
                use in other areas of the food and drink industry, working towards our goal of
                bringing consumers and producers closer together.
              </p>
              <div className="section">
                <h4>{this.props.headingsectionone}</h4>
                {this.props.sectionone}
              </div>
              <div className="section">
                <h4>{this.props.headingsectiontwo}</h4>
                {this.props.sectiontwo}
              </div>
              <div className="section">
                <h4> {this.props.headingsectionthree} </h4>
                {this.props.sectionthree}
              </div>
              <div className="section">
                <h4> {this.props.headingsectionfour} </h4>
                {this.props.sectionfour}
              </div>
              <div className="section">
                <h5>{this.props.salary}</h5>
              </div>
              <div className="apply">
                <h5>If you think this is for you, we’d love to hear from you at <a href="mailto:info@distilledID.com">info@distilledID.com</a></h5>
              </div>
            </Col>
          </Row>
          {this.props.children}
        </Grid>
      </div >
    );
  }
}

export default JobAdvertLayout;



// WEBPACK FOOTER //
// ./src/components/common/JobAdvertLayout.js